import { StreamVideoProps } from '@/types';

export const StreamVideo = ({ videoUrl }: StreamVideoProps) => {
  return (
    <div className='h-2/5 w-full object-cover md:h-2/3'>
      <video src={videoUrl} autoPlay controls width='100%' height='100%' className='rounded-2xl' />
    </div>
  );
};
